// main.js
import Button    from 'bootstrap/js/dist/button';
import Carousel  from 'bootstrap/js/dist/carousel';
import Collapse  from 'bootstrap/js/dist/collapse';
import Dropdown  from 'bootstrap/js/dist/dropdown';
import Modal     from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Tab       from 'bootstrap/js/dist/tab';
import Tooltip   from 'bootstrap/js/dist/tooltip';
import ScrollSpy from 'bootstrap/js/dist/scrollspy';

// Your modules — **after** bootstrap imports
import './global-js/utilities/breakpoint-helpers.js';
import './global-js/utilities/popover.js';
import './global-js/utilities/swiper.js';
import './global-js/utilities/sticky-cta.js';
import './global-js/utilities/fetch.js';
import './global-js/utilities/url.js';
import './global-js/topnav/sticky-top-nav.js';
import './global-js/topnav/nav-dropdown-desktop.js';
import './global-js/topnav/nav-dropdown-mobile.js';
import './global-js/topnav/search-desktop.js';
import './global-js/topnav/pre-nav-banner.js';
import './global-js/mega-menu/mega-menu.js';

// Set up globally accessible functions, objects and variables here:
const bootstrap = {
	Button,
	Carousel,
	Collapse,
	Dropdown,
	Modal,
	Offcanvas,
	Tab,
	Tooltip,
	ScrollSpy
};

const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new Tooltip(tooltipTriggerEl);
});

// DEBUGGING Purpose: show all tooltips
// tooltipList.forEach(tooltip => tooltip.show());

window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', function() {
	const blockNavigation = document.querySelector('#block-navigation');
	const sidebarNavigation = document.querySelector('#page-sidebar');
	let isJumpLinkScroll = false;
	let jumpLinkTimeout = null;

	const topNav = document.querySelector('#top-nav');
	if(!topNav) return;

	if(blockNavigation) {
		const blockNavigationLinks = blockNavigation.querySelectorAll('.block-nav-link');
	
		if(blockNavigationLinks.length > 0) {
			blockNavigationLinks.forEach(link => {
				link.addEventListener('click', function(e) {
					e.preventDefault();
					const anchor = link.getAttribute('href');
					if(!anchor) return;
	
					const anchorElement = document.querySelector(anchor);
					if(!anchorElement) return;

					isJumpLinkScroll = true;

					jumpLinkTimeout = setTimeout(() => {
						isJumpLinkScroll = false;
					}, 1500);
	
					let totalNavHeight = getTotalNavHeight();
					totalNavHeight += blockNavigation.offsetHeight;
	
					const anchorOffset = anchorElement.offsetTop - totalNavHeight;
	
					window.scrollTo({
						top: anchorOffset,
						behavior: 'smooth'
					});
				});
			});
		}
	}

	window.addEventListener('scroll', function(e) {
		let totalNavHeight = getTotalNavHeight();

		let element = blockNavigation || sidebarNavigation;

		if(element === sidebarNavigation && window.innerWidth > 1024) {
			return;
		}

		let computedOffsetTop = getComputedStyle(element).getPropertyValue('--offset-top') ?? 0;
		let computedOffsetTopValue = parseInt(computedOffsetTop);

		if(computedOffsetTopValue !== totalNavHeight) {
			element.style.setProperty('--offset-top', totalNavHeight + 'px');
		}
		
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		scrollTop = Math.round(scrollTop + totalNavHeight);

		const elementTop = element.offsetTop;

		// detect if the user is scroll or has pressed a jump link
		if(isJumpLinkScroll) {
			element.classList.add('nav-touching-sticky');
		} else if(scrollTop >= elementTop) {
			element.classList.add('nav-touching-sticky');
			topNav.classList.add('nav-touching-sticky');
		} else {
			element.classList.remove('nav-touching-sticky');
			topNav.classList.remove('nav-touching-sticky');
		}
	});

	const scrollSpyEl = document.querySelector('[data-bs-spy="scroll"]');
	const mobileBlockNavigation = document.querySelector('#block-navigation-select');
	if(scrollSpyEl && mobileBlockNavigation) {
		scrollSpyEl.addEventListener('activate.bs.scrollspy', function(e) {
			const targetAnchor = e.relatedTarget.getAttribute('href');
			mobileBlockNavigation.value = targetAnchor;
		});
	}
});

function getTotalNavHeight() {
	let totalHeight = 0;
	const topNav = document.querySelector('#top-nav');
	const adminBar = document.querySelector('#wpadminbar');

	if(topNav) {
		totalHeight += topNav.offsetHeight;
	}

	if(adminBar && window.innerWidth > 600) {
		totalHeight += adminBar.offsetHeight;
	}

	return totalHeight;
}

// Move all modals to the end of <body> to avoid z-index issues
document.querySelectorAll('.modal').forEach(modal => {
	document.body.appendChild(modal);
});